export enum DoaForecastList {
  available = 'availability-list',
  shortage = 'shortage-list',
  jobs = 'jobs-required'
}

export enum DoaForecastTableColor {
  green = 'green',
  red = 'red'
}

export enum DoaForecastFilterBoardType {
  union = 'union',
  casual = 'casual'
}

export enum SortType {
  buttonPosition = 'buttonPosition',
  boardPlate = 'boardPlate',
  name = 'name',
}

export enum SortTypeDescription {
  buttonPosition = 'Button Position',
  boardPlate = 'Board/Plate',
  name = 'Name',
}

export const SORT_TYPE_DESCRIPTIONS = Object.entries(SortTypeDescription).map(
  ([key, value]) => ({ code: key, display: value })
);
